import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "AppLayout w-full h-screen" };
const _hoisted_2 = {
    key: 0,
    class: "AppLayout__UI absolute inset-0 flex flex-col lg:p-24 lg:pb-20 pointer-events-none"
};
const _hoisted_3 = { class: "absolute inset-x-0 bottom-0 flex flex-col items-center justify-end lg:w-cols-10 mx-auto p-16 pb-20 lg:pb-32 pointer-events-none" };
import { ref, computed, defineAsyncComponent, watch, onMounted, onBeforeUnmount } from "vue";
import Viewport from "@/store/modules/Viewport";
import LayoutTheme from "@/store/modules/LayoutTheme";
import AppService from "@/services/AppService";
import { useAppContext, useAppState, useStoryState } from "@/services/Composition";
import { setCursorHover, setCursorVisible } from "@/store/modules/Cursor";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppLayout',
    setup(__props) {
        const LazyAppCursor = defineAsyncComponent(() => import("../App/AppCursor.vue"));
        const { state } = useAppState();
        const { state: storyState } = useStoryState();
        const isAppReady = useAppContext("loaded");
        const isEntered = ref(process.env.VUE_APP_SKIP_INTRO === "true");
        const showEnterCTA = computed(() => state.value.matches("loaded"));
        const canSkip = computed(() => ["home.home.page", "story"].some(state.value.matches));
        const showSkipCTA = computed(() => state.value.can("SKIP") || storyState.value.can("SKIP"));
        const showUI = computed(() => ["home", "story", "dit", "end"].some(state.value.matches));
        const showHeader = computed(() => !(state.value.matches("home.landing") || storyState.value.matches("story.scene.media.default")));
        const showCaptions = computed(() => !storyState.value.matches("story.scene.media"));
        function onAfterEnterCTALeave() {
            if (isAppReady.value && !showEnterCTA.value) {
                isEntered.value = true;
            }
        }
        watch(isAppReady, setCursorVisible, { immediate: true });
        watch([isAppReady, showEnterCTA], ([isAppReady, showEnterCTA]) => {
            if (Viewport.isTouch && isAppReady && !showEnterCTA) {
                isEntered.value = true;
            }
        });
        let watchState;
        onMounted(() => {
            watchState = AppService.state.subscribe(() => {
                setCursorHover(false);
            });
        });
        onBeforeUnmount(() => {
            watchState === null || watchState === void 0 ? void 0 : watchState.unsubscribe();
        });
        return (_ctx, _cache) => {
            const _component_AppHeader = _resolveComponent("AppHeader");
            const _component_AppFooter = _resolveComponent("AppFooter");
            const _component_AppCaptions = _resolveComponent("AppCaptions");
            const _component_UIBtn = _resolveComponent("UIBtn");
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default"),
                (showUI.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _withDirectives(_createVNode(_component_AppHeader, {
                            class: "mb-auto px-20 lg:px-0",
                            theme: _unref(LayoutTheme).header
                        }, null, 8, ["theme"]), [
                            [_vShow, showHeader.value]
                        ]),
                        _createVNode(_component_AppFooter, {
                            class: "mt-auto p-20 lg:p-0",
                            theme: _unref(LayoutTheme).footer
                        }, null, 8, ["theme"]),
                        _createElementVNode("div", _hoisted_3, [
                            _withDirectives(_createVNode(_component_AppCaptions, null, null, 512), [
                                [_vShow, showCaptions.value]
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(Viewport).isTouch)
                    ? (_openBlock(), _createBlock(_unref(LazyAppCursor), {
                        key: 1,
                        theme: _unref(LayoutTheme).header,
                        padding: 80
                    }, {
                        default: _withCtx(({ placement, isDefault: isCursorDefault, isVisible: isCursorVisible }) => [
                            (!isEntered.value)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["absolute px-32", [placement === 'left' ? 'right-full' : 'left-full']])
                                }, [
                                    _withDirectives(_createVNode(_component_UIBtn, {
                                        as: "span",
                                        variant: "solid",
                                        theme: "light",
                                        onAfterLeave: onAfterEnterCTALeave
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("preloader.cta")), 1)
                                        ]),
                                        _: 2
                                    }, 1536), [
                                        [_vShow, showEnterCTA.value && isCursorVisible]
                                    ])
                                ], 2))
                                : (canSkip.value)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: _normalizeClass(["absolute px-32", [placement === 'left' ? 'right-full' : 'left-full']])
                                    }, [
                                        _withDirectives(_createVNode(_component_UIBtn, {
                                            as: "span",
                                            variant: "solid",
                                            theme: "light"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t("global.skip")), 1)
                                            ]),
                                            _: 2
                                        }, 1536), [
                                            [_vShow, showSkipCTA.value && isCursorVisible && isCursorDefault]
                                        ])
                                    ], 2))
                                    : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["theme"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
